/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Pricing_Feature_NofollowInputs */

const en_landing_pricing_feature_nofollow = /** @type {(inputs: Landing_Pricing_Feature_NofollowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nofollow outbound links`)
};

const zh_landing_pricing_feature_nofollow = /** @type {(inputs: Landing_Pricing_Feature_NofollowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nofollow 外链`)
};

/**
* | output |
* | --- |
* | "Nofollow outbound links" |
*
* @param {Landing_Pricing_Feature_NofollowInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_pricing_feature_nofollow = /** @type {((inputs?: Landing_Pricing_Feature_NofollowInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Pricing_Feature_NofollowInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_pricing_feature_nofollow(inputs)
	return zh_landing_pricing_feature_nofollow(inputs)
});
export { landing_pricing_feature_nofollow as "landing.pricing.feature_nofollow" }